import HomeOutlineTen from '@assets/icons/home-outline-ten.svg'
import { Icon } from './Icon'

export const HomeOutlineTenIcon = Icon(HomeOutlineTen)
